module.exports = __webpack_public_path__ + "images/dingtalk-phone@2x-d4c17aced7afc23d62c5b35d9fb28d82.png";